import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=186b70f8&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186b70f8')) {
      api.createRecord('186b70f8', component.options)
    } else {
      api.reload('186b70f8', component.options)
    }
    module.hot.accept("./Information.vue?vue&type=template&id=186b70f8&", function () {
      api.rerender('186b70f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/Information.vue"
export default component.exports